import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { money, date } from '../lib/format.js';

export default function PublicView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    fetch(`/api/public/${token}`).then(r => r.ok ? r.json() : r.json().then(e => { throw e; })).then(setData).catch(e => setErr(e.error || 'Not found'));
  }, [token]);
  if (err) return <div className="auth-shell"><div className="auth-card"><h1>Document not found</h1><p className="muted">{err}</p></div></div>;
  if (!data) return <div className="auth-shell"><span className="spinner" /></div>;
  const d = data.document;
  const c = data.company;
  return (
    <div style={{ padding: '40px 20px', maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          {c?.logoUrl && <img src={c.logoUrl} alt="" style={{ maxHeight: 60, marginBottom: 12 }} />}
          <h1 style={{ margin: 0 }}>{c?.name}</h1>
          <div className="muted">{c?.address} {c?.city}</div>
          {c?.nuis && <div className="muted">NUIS: {c.nuis}</div>}
        </div>
        <div style={{ textAlign: 'right' }}>
          <h1 style={{ margin: 0, color: 'var(--navy-900)' }}>{d.type.replace('_', ' ')}</h1>
          <div style={{ color: 'var(--steel)', fontWeight: 600 }}>{d.fullNumber}</div>
          <a className="btn btn-primary mt-16" href={`/api/public/${token}/pdf`} target="_blank" rel="noreferrer">Download PDF</a>
        </div>
      </div>

      <div className="row">
        <div className="card"><h3>Bill to</h3>
          <div><strong>{d.client.name}</strong></div>
          {d.client.legalName && <div className="muted">{d.client.legalName}</div>}
          <div>{d.client.address} {d.client.city} {d.client.country}</div>
          {d.client.nuis && <div>NUIS: {d.client.nuis}</div>}
        </div>
        <div className="card">
          <div>Issue: {date(d.issueDate)}</div>
          {d.dueDate && <div>Due: {date(d.dueDate)}</div>}
          <div>Currency: {d.currencyCode}</div>
          <div>Status: {d.status}</div>
        </div>
      </div>

      <table className="table mt-16">
        <thead><tr><th>Item</th><th style={{ textAlign: 'right' }}>Qty</th><th>Unit</th><th style={{ textAlign: 'right' }}>Price</th><th style={{ textAlign: 'right' }}>Total</th></tr></thead>
        <tbody>
          {d.items.map(it => (
            <tr key={it.id}>
              <td><strong>{it.name}</strong>{it.description && <div className="muted">{it.description}</div>}</td>
              <td style={{ textAlign: 'right' }}>{Number(it.qty).toFixed(2)}</td>
              <td>{it.unit}</td>
              <td style={{ textAlign: 'right' }}>{money(it.unitPrice, d.currencyCode)}</td>
              <td style={{ textAlign: 'right' }}>{money(it.lineTotal, d.currencyCode)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="card" style={{ maxWidth: 320, marginLeft: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>VAT</span><strong>{money(d.vatTotal, d.currencyCode)}</strong></div>
        <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '2px solid var(--navy-900)', marginTop: 8, paddingTop: 8, fontSize: 18, color: 'var(--navy-900)' }}>
          <span>Total</span><strong>{money(d.total, d.currencyCode)}</strong>
        </div>
      </div>

      {(d.notes || d.terms || c?.bankIban) && (
        <div className="card mt-16">
          {d.notes && <><h3>Notes</h3><div>{d.notes}</div></>}
          {d.terms && <><h3>Terms</h3><div>{d.terms}</div></>}
          {c?.bankIban && <><h3>Bank details</h3><div>{c.bankName} · IBAN: {c.bankIban}{c.bankSwift ? ` · SWIFT: ${c.bankSwift}` : ''}</div></>}
        </div>
      )}
    </div>
  );
}
